import { inject, Inject, Pipe, PipeTransform } from '@angular/core';
import { USER_FORMAT, UserDateFormat } from '@agilox/common';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
	name: 'customDate',
})
export class CustomDatePipe implements PipeTransform {
	@Inject(USER_FORMAT) private userFormat = inject(USER_FORMAT);
	private datePipe = inject(DatePipe);
	private translate = inject(TranslateService);

	transform(
		value: number | string | undefined | null,
		timezone?: string,
		customFormat?: string
	): any {
		return this.datePipe.transform(
			value,
			customFormat !== undefined ? customFormat : this.formatFormat(this.userFormat().date),
			timezone,
			this.translate.currentLang
		);
	}

	private formatFormat(format: UserDateFormat): string {
		return format
			.replace(/-/g, '')
			.replace(/dot/g, '.')
			.replace(/slash/g, '/')
			.replace(/hyphen/g, '-')
			.replace(/m/g, 'M');
	}
}
